// extracted by mini-css-extract-plugin
module.exports = {"modal":"PatientDocumentInfo_modal__1-z8D"};